/* eslint-ignore */
// @ts-nocheck
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { ReactComponent as ArrowLeftIc } from '~/assets/icons/arrow-left.svg';
import { ReactComponent as ArrowRightIc } from '~/assets/icons/arrow-right.svg';
import { ReactComponent as ArrowTopIc } from '~/assets/icons/arrow-top.svg';

export const Scrollbar = styled.div`
  height: 87vh;
  ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    background: #f5f5f5;
  }
`;

export const HeaderPage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.blue};
  font-weight: bold;

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 10px 0px 20px 0px;
`;

export const TitleSection = styled.h1`
  color: ${({ theme }) => theme.colors.purple};
  font-size: 16px;
  margin: 30px 0px;
  font-weight: bold;
`;

export const Table = styled.table`
  width: 100%;

  @media (max-width: 930px) {
    display: none;
  }
`;

export const Thead = styled.thead`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 20px 40px;
  text-align: center;
  @media (max-width: 1100px) {
    top: 56px;
  }
`;

export const Th = styled.th`
  font-size: 12px;
  font-weight: 700;
  color: #464646;
  width: 100%;
`;

export const Tr = styled.tr`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 20px;
  margin: 0 20px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #0000001a;
  border-radius: 10px;
  margin-bottom: 20px;
  + tr {
    margin-top: 20px;
  }
`;

export const Tbody = styled.tbody`
  padding: 20px 20px;  
`;

export const Td = styled.td`
  display: flex;
  justify-content: ${(props) => (props.right ? 'flex-end' : 'flex-start')};
  align-items: center;
  width: 100%;
  justify-content: center;
  font-size: 14px;  
`;

export const StatusTitle = styled.div``;

export const Status = styled.div`
  min-width: 10px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.color};
  background: ${(props) => props.color};
  margin-right: 10px;
`;

export const BoxPadding = styled.div`
  padding: 0px 20px;
`;

// Cards

export const Cards = styled.div`
  display: block;
  padding: 0px 20px;
  @media (min-width: 931px) {
    display: none;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 20px;
  margin-bottom: 10px;

  ${Hr} {
    border-color: #ececec;
    border-style: solid;
  }
`;

export const CardLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const CodeTitle = styled.div`
  font-size: 16px;
  color: #515151;
`;

export const Code = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.purple};
  margin-left: 10px;
`;

export const TitleLine = styled.div`
  font-size: 12px;
  color: #515151;
  font-weight: bold;
`;

export const BtnLine = styled(TitleLine)`
  border: 1px solid rgba(0, 0, 0, 0.3);
  padding: 3px 10px;
  border-radius: 4px;
`;

export const DescriptionLine = styled.div`
  font-size: 12px;
  color: #515151;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
`;

export const ArrowLeftIcon = styled(ArrowLeftIc)`
  margin-left: 20px;
  margin-right: 10px;

  &:hover {
    cursor: pointer;
  }

  path,
  .a {
    fill: #656565;
  }
  path,
  .b {
    fill: #656565;
  }
`;

export const ArrowRightIcon = styled(ArrowRightIc)`
  &:hover {
    cursor: pointer;
  }
  path,
  .a {
    fill: #656565;
  }
  path,
  .b {
    fill: #656565;
  }
`;

export const Option = styled.option``;

export const CreateSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;

  @media (max-width: 1175px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldName = styled.span`
  color: ${(props) =>
    props.range ? '#3E3E3E' : `${({ theme }) => theme.colors.mediumGray}`};
  margin-bottom: ${(props) => (props.range ? '10px' : '')};
  transition: font-size 1s;
  transform: translateY(-3px);
  font-size: 0.625rem;

  &:hover {
    cursor: pointer;
  }
`;

export const Input = styled.div`
  position: relative;
  display: flex;
  background: ${(props) => (props.range ? 'transparent' : 'white')};
  border-radius: 5px;
  width: 100%;
  color: ${({ theme }) => theme.colors.gray};
  padding: 8px 12px 8px 12px;
  height: 50px;
  flex-direction: column;
  border: ${(props) => (props.range ? 'none' : `1px solid #C1C1C1`)};

  @media (max-width: 1175px) {
    max-width: 100%;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Select = styled.select`
  position: absolute;
  display: flex;
  width: 93%;
  height: 40px;
  flex: 1;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  outline: none !important;
  padding: 0;
  font-size: 12px;

  &::placeholder {
    color: #666360;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Pagination = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  color: #0018FF;
`;

export const Button = styled.div`
  width: 100%;
  height: 50px;
  background: ${(props) => props.theme.colors.blue};
  color: #fff;
  border-radius: 5px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 1175px) {
    max-width: 100%;
  }
  cursor: pointer;
`;

export const StyledModal = styled(Modal)`
  .modal-dialog {
    @media (min-width: 640px) {
      max-width: 600px !important;
    }
    @media (max-width: 640px) {
      max-width: 100% !important;
    }
  }
`;

export const TopList = styled.div`
  width: 44px;
  height: 44px;
  display: ${(props) => (props.active ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 22px;

  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 20px;
  margin-bottom: 20px;

  &:hover {
    cursor: pointer;
  }
`;

export const ArrowTopIcon = styled(ArrowTopIc)``;

export const DuplicateIcon = styled.i`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px !important;
  margin-left: -20px;
`;
